// index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationsAm from './i18n-am'
import translationsEn from './i18n-en'
import translationsRu from './i18n-ru'

const resources = {
  en: {
    translation: translationsEn,
  },
  ru: {
    translation: translationsRu,
  },
  am: {
    translation: translationsAm,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
